/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { defineAsyncComponent } from '@vue/composition-api';

/** 认识臻有钱 */
export const KnowFinancePanel = defineAsyncComponent(() => import(
  /* webpackChunkName: "know-finance-panel" */ './components/KnowFinancePanel/index.vue'
));

/** 提升额度区域 */
export const IncreaseCreditZone = defineAsyncComponent(() => import(
  /* webpackChunkName: "increase-credit-zone" */ './components/IncreaseCreditZone/index.vue'
));

/** 风险声明 */
export const RiskStatement = defineAsyncComponent(() => import(
  /* webpackChunkName: "risk-statement" */ './components/RiskStatement/index.vue'
));

/** 首页banner */
export const AdvBanners = defineAsyncComponent(() => import(
  /* webpackChunkName: "adv-banners" */ '@/components/adv-components/adv-banners'
));

/** “我的”浮标：借钱Tab流量入口 */
export const UserCenterFloat = defineAsyncComponent(() => import(
  /* webpackChunkName: "user-center-float" */ '@/components/user-center-float'
));

/** 首页右下角浮标 */
export const AdvHomeFloat = defineAsyncComponent(() => import(
  /* webpackChunkName: "adv-home-float" */ '@/components/adv-components/adv-home-float'
));

/** 天下信用banner */
export const TxxyBanner = defineAsyncComponent(() => import(
  /* webpackChunkName: "txxy-banner" */ '@/views_v2/home/components/adv-txxy-banner/index.vue'
));
